export default __webpack_public_path__ + "static/media/MarkerCustomer.4ae590ac.svg";